import React from "react";
import { Reveal, WfButton } from "@/components/site/primitives";
import { ORG, STATS, PHOTO_CREDIT } from "@/content/worldFarmers";
import { scrollToId } from "@/lib/scrollTo";

export const StoryV4 = () => {
  const go = (id) => (e) => { e.preventDefault(); scrollToId(id); };
  return (
    <section id="about" aria-labelledby="story-v4-heading" className="bg-[var(--wf-cream)] py-16 sm:py-20 lg:py-28">
      <div className="wf-container grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
        {/* Image with floating stat pills */}
        <Reveal>
          <div className="relative">
            <div className="overflow-hidden rounded-sm border border-[var(--wf-border)] shadow-[var(--wf-shadow)]">
              <img src="/images/wf/farm-017.jpg" alt="A farmer smiling warmly while standing in a lush green agricultural field." loading="lazy" className="aspect-[4/5] w-full object-cover" />
            </div>
            <div className="absolute -left-3 top-8 rounded-sm border border-[var(--wf-border)] bg-white px-4 py-3 shadow-[var(--wf-shadow)] sm:-left-6">
              <div className="font-serif text-2xl font-semibold text-[var(--wf-maroon)]">1,200+</div>
              <div className="text-[11px] uppercase tracking-[0.12em] text-muted-foreground">Farmers supported</div>
            </div>
            <div className="absolute -right-3 bottom-10 rounded-sm border border-[var(--wf-border)] bg-[var(--wf-farm-green)] px-4 py-3 text-white shadow-[var(--wf-shadow)] sm:-right-6">
              <div className="font-serif text-2xl font-semibold">40 yrs</div>
              <div className="text-[11px] uppercase tracking-[0.12em] text-white/80">Growing together</div>
            </div>
            <span className="pointer-events-none absolute bottom-3 left-3 rounded-full bg-black/40 px-3 py-1 text-[11px] font-medium text-white/90 backdrop-blur-sm">{PHOTO_CREDIT.label}</span>
          </div>
        </Reveal>

        {/* Narrative */}
        <div>
          <Reveal>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--wf-green-text)]">Who we are</span>
            <h2 id="story-v4-heading" className="mt-3 font-serif text-3xl font-semibold leading-tight text-[var(--wf-ink)] sm:text-4xl lg:text-5xl">
              A community rooted in good food and good neighbors.
            </h2>
            <p className="mt-5 max-w-[56ch] text-base leading-7 text-muted-foreground">
              {ORG.missionFull}
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <dl className="mt-9 grid grid-cols-2 gap-x-6 gap-y-6 sm:grid-cols-4">
              {STATS.map((s) => (
                <div key={s.id}>
                  <dt className="sr-only">{s.label}</dt>
                  <dd className="font-serif text-3xl font-semibold text-[var(--wf-maroon)]">{s.value}</dd>
                  <p className="mt-1 text-[11px] uppercase tracking-[0.12em] text-muted-foreground">{s.label}</p>
                </div>
              ))}
            </dl>
          </Reveal>

          <Reveal delay={0.16}>
            <div className="mt-9">
              <WfButton as="a" href="#programs" onClick={go("programs")} withArrow className="px-6" data-testid="about-learn-more-button">
                Explore our programs
              </WfButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
